module.exports = __webpack_public_path__ + "img/7.eac8a799.jpg";